import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import Helmet from 'next/head';
import { StrictMode, useEffect } from 'react';
import { Showcase, SlyPartnerBanner } from 'sly/b2b';
import {
  affiliateSolutions,
  CALENDER_LINK_CHRISTINE,
  conciergeSolutions,
  eapSolutions,
  enterpriseSolutions,
  financialSolutions,
} from 'sly/b2b/constants';
import { pageNames, useEvents } from 'sly/services/events';

import HeaderBanner from './HeaderBanner';

export default function CommunitiesIndex() {
  const { events } = useEvents();

  useEffect(() => {
    events.page(pageNames.PartnerSeniorAdjacentIndustries, {});
  }, [events]);

  return (
    <StrictMode>
      <Helmet>
        <title>Senior Living Companies and Providers | Seniorly</title>
        <meta
          name='description'
          content='Take a look at some of the largest senior living companies in the country. Seniorly can help you find out more about different senior living providers.'
        />
      </Helmet>
      <header className='relative'>
        <Header />
      </header>
      <HeaderBanner />
      {/* <Showcase
        title={realEstateSolutions.title}
        items={realEstateSolutions.solutions}
        startImageOnRight
      />
      <hr /> */}
      <Showcase
        title={financialSolutions.title}
        items={financialSolutions.solutions}
      />
      <hr />
      <Showcase title={eapSolutions.title} items={eapSolutions.solutions} />
      <hr />
      <Showcase
        title={enterpriseSolutions.title}
        description={enterpriseSolutions.description}
        items={enterpriseSolutions.solutions}
      />
      <hr />
      <Showcase
        title={conciergeSolutions.title}
        description={conciergeSolutions.description}
        items={conciergeSolutions.solutions}
      />
      <hr />
      <Showcase
        title={affiliateSolutions.title}
        description={affiliateSolutions.description}
        items={affiliateSolutions.solutions}
      />
      <SlyPartnerBanner
        page='B2B senior adjacent industries'
        link={CALENDER_LINK_CHRISTINE}
      />
      <Footer />
    </StrictMode>
  );
}

CommunitiesIndex.whyDidYouRender = true;
